angular.module('mychart').config(['AppRoutesProvider', '$stateProvider', '$urlRouterProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'chart' };

        var appRoutes = {
            'myChart': {
                state: 'myChart',
                route: '/myChart',
                portalSettings: portalSettings
            },
            'myChartProblems': {
                state: 'myChart.myChartProblems',
                route: '/problems/:id',
                portalSettings: portalSettings
            },
            'myChartPrescriptions': {
                state: 'myChart.myChartPrescriptions',
                route: '/rxrefill/:id',
                portalSettings: portalSettings
            },
            'myChartVisitSummary': {
                state: 'myChart.myChartVisitSummary',
                route: '/visitSummary/:id',
                portalSettings: portalSettings
            },
            'myChartProcedures': {
                state: 'myChart.myChartProcedures',
                route: '/procedures/:id',
                portalSettings: portalSettings
            },
            'myChartLabResults': {
                state: 'myChart.myChartLabResults',
                route: '/labResults/:id',
                portalSettings: portalSettings
            },
            'myChartImmunizations': {
                state: 'myChart.myChartImmunizations',
                route: '/immunizations/:id',
                portalSettings: portalSettings
            },
            'myChartReferenceMaterial': {
                state: 'myChart.myChartReferenceMaterial',
                route: '/referenceMaterial/:id',
                portalSettings: portalSettings
            },
            'myChartMedicationAllergies': {
                state: 'myChart.myChartMedicationAllergies',
                route: '/medicationAllergies/:id',
                portalSettings: portalSettings
            },
            'myChartPersonalDetails': {
                state: 'myChart.myChartPersonalDetails',
                route: '/personalDetails/:id',
                portalSettings: portalSettings
            },
            'shareCCD': {
                state: 'shareCCD',
                route: '/shareCCD/',
                portalSettings: portalSettings
            },
            'loadingDocument': {
                state: 'loadingDocument',
                route: '/loadingDocument/',
                portalSettings: {
                    hideHeader: true,
                    hideToolbar: true,
                    hideFooter: true
                }
            },
            'chartConsent': {
                state: 'myChart.chartConsent',
                route: '/chartConsent/:redirectRoute',
                portalSettings: {
                    toolbarItem: 'blank'
                }
            },
            'myChartMobile': {
                state: 'myChartMobile',
                route: '/myChartMobile/:openPD',
                portalSettings: portalSettings                
            },
            'chartMobileConsent': {
                state: 'myChartMobile.chartConsent',
                route: '/chartConsent/:redirectRoute',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.myChart.state, {
                url: appRoutes.myChart.route,
                templateUrl: '/mychart/views/myChart.html',
                controller: 'MyChartCtrl',
                description: '/myChart'
            })
            .state(appRoutes.myChartVisitSummary.state, {
                url: appRoutes.myChartVisitSummary.route,
                templateUrl: '/mychart/views/visitSummary.html',
                controller: 'VisitSummaryCtrl',
                description: '/VisitSummary',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Visit Summary'); }
                }
            })
            .state(appRoutes.myChartProblems.state, {
                url: appRoutes.myChartProblems.route,
                templateUrl: '/mychart/views/problems.html',
                controller: 'ProblemsCtrl',
                description: 'Problems',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Problems'); }
                }
            })
            .state(appRoutes.myChartProcedures.state, {
                url: appRoutes.myChartProcedures.route,
                templateUrl: '/mychart/views/procedures.html',
                controller: 'ProceduresCtrl',
                description: '/Procedures',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Procedures'); }
                }
            })
            .state(appRoutes.myChartLabResults.state, {
                url: appRoutes.myChartLabResults.route,
                templateUrl: '/mychart/views/labResults.html',
                controller: 'LabResultsCtrl',
                description: '/LabResults',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Test Results'); }
                }
            })
            .state(appRoutes.myChartImmunizations.state, {
                url: appRoutes.myChartImmunizations.route,
                templateUrl: '/mychart/views/immunizations.html',
                controller: 'ImmunizationsCtrl',
                description: '/Immunizations',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Immunizations'); }
                }
            })
            .state(appRoutes.myChartPrescriptions.state, {
                url: appRoutes.myChartPrescriptions.route,
                templateUrl: '/mychart/views/prescriptionsList.html',
                controller: 'RxRefillCtrl',
                description: '/Prescriptions',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Prescriptions'); }
                }
            })
            .state(appRoutes.myChartReferenceMaterial.state, {
                url: appRoutes.myChartReferenceMaterial.route,
                templateUrl: '/mychart/views/referenceMaterial.html',
                controller: 'ReferenceMaterialCtrl',
                description: '/ReferenceMaterial',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Educational Material'); }
                }
            })
            .state(appRoutes.myChartMedicationAllergies.state, {
                url: appRoutes.myChartMedicationAllergies.route,
                templateUrl: '/mychart/views/medicationAllergies.html',
                controller: 'MedicationAllergiesCtrl',
                description: '/ReferenceMaterial',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Medication Allergies'); }
                }
            })
            .state(appRoutes.myChartPersonalDetails.state, {
                url: appRoutes.myChartPersonalDetails.route,
                templateUrl: '/mychart/views/personalDetails.html',
                controller: 'PersonalDetailsCtrl',
                description: '/PersonalDetails',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Patient Overview'); }
                }
            })
            .state(appRoutes.shareCCD.state, {
                url: appRoutes.shareCCD.route,
                templateUrl: '/mychart/views/shareCCD.html',
                controller: 'ShareCCDCtrl',
                description: '/PersonalDetails',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Continuity Care Document'); }
                }
            })
            .state(appRoutes.loadingDocument.state, {
                url: appRoutes.loadingDocument.route,
                templateUrl: '/mychart/views/loadingDocument.html',
                controller: '',
                description: '/MyChart'
            })
            .state(appRoutes.chartConsent.state, {
                url: appRoutes.chartConsent.route,
                templateUrl: '/mychart/views/chartConsent.html',
                controller: 'ChartConsentCtrl',
                description: '/ChartConsent',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Patient Chart Consent'); }
                }
            })
            .state(appRoutes.myChartMobile.state, {
                url: appRoutes.myChartMobile.route,
                templateUrl: '/mychart/views/myChartMobile.html',
                controller: 'MyChartMobileCtrl',
                description: '/MyChartMobile'
            })
            .state(appRoutes.chartMobileConsent.state, {
                url: appRoutes.chartMobileConsent.route,
                templateUrl: '/mychart/views/chartConsent.html',
                controller: 'ChartConsentCtrl',
                description: '/ChartMobileConsent',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Patient Chart Consent'); }
                }
            });
    }]);